@if (dataSource && columnsData) {
  <icz-table
    [id]="tableId"
    [tableTitle]="tableTitle"
    [dataSource]="dataSource"
    [columnsData]="columnsData"
    (selectedRowsChanged)="selectedRows = $event"
    (contextMenuRequested)="toolbar.openContextMenu($event)"
    (activeRowChanged)="setActiveRow($event)"
    #iczTable
  >

    <ng-content select="[tableTitle]" tableTitle></ng-content>
    <ng-content select="[tableTabs]" tableTabs></ng-content>
    <ng-content select="[noDataLabel]" noDataLabel></ng-content>

    <icz-storage-unit-filler-toolbar-buttons
      tools #toolbar
      [selectedRows]="selectedRows"
      (operationCompleted)="unselectAndReload()"
    ></icz-storage-unit-filler-toolbar-buttons>

    <ng-container *iczColumnTemplate="let row from [dataSource, columnsData]; id: StorageUnitFillerTableColumn.ID; withEllipsis: true; let column = column">
      <span>
        <a class="p-4" iczLinkWithoutHref (click.stop)="openStorageUnitFillerDetailSettingsTab(row)">
          {{ row.id }}
        </a>
      </span>
    </ng-container>
    <ng-container *iczColumnTemplate="let row from [dataSource, columnsData]; id: StorageUnitFillerTableColumn.REJECTED_ENTITIES; withEllipsis: true">
      <span>
        @if ($any(row)?.statistics?.entitiesRejectedCount > 0) {
          <a class="p-4" iczLinkWithoutHref (click.stop)="openStorageUnitFillerDetailErroredEntities(row)">
            {{ $any(row)?.statistics?.entitiesRejectedCount }}
          </a>
        } @else {
          {{ $any(row)?.statistics?.entitiesRejectedCount }}
        }
      </span>
    </ng-container>
    <ng-container *iczColumnTemplate="let row from [dataSource, columnsData]; id: StorageUnitFillerTableColumn.EXPECTED_ENTITIES; withEllipsis: true">
      <span>{{row.statistics?.documentsToInsertCount !== null ? row.statistics?.documentsToInsertCount! + row.statistics?.filesToInsertCount! : ''}}</span>
    </ng-container>
    <ng-container *iczColumnTemplate="let row from [dataSource, columnsData]; id: StorageUnitFillerTableColumn.HUMAN_READABLE_FILTER; withEllipsis: true">
      <span class="icz-body-1 mt-4" [innerHTML]="row.humanReadableFilter"></span>
    </ng-container>

  </icz-table>
}
